import { render } from "./EventListTable.vue?vue&type=template&id=8007263a&scoped=true"
import script from "./EventListTable.vue?vue&type=script&lang=js"
export * from "./EventListTable.vue?vue&type=script&lang=js"

import "./EventListTable.vue?vue&type=style&index=0&id=8007263a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8007263a"]])

export default __exports__